import { useQuery } from "@tanstack/react-query";
import { fetchDashboardStats, fetchBookingTrends, fetchDriverBookingPerformance, fetchVehicleBookingCounts, fetchVehicleCategoryDistribution, fetchTodayRevenueExpense, fetchVehicleAvailabilityCalendar } from "./dashboard.service";

export const useDashboardStats = () => {
  return useQuery({
    queryKey: ["dashboardStats"],
    queryFn: fetchDashboardStats,
    staleTime: 1 * 60 * 1000,
  })
}

export const useBookingTrends = (params) => {
  return useQuery({
    queryKey: ["bookingTrends", params],
    queryFn: () => fetchBookingTrends(params),
    staleTime: 1 * 60 * 1000,
  })
}

export const useDriverBookingPerformance = (params) => {
  return useQuery({
    queryKey: ["driverBookingPerformance", params],
    queryFn: () => fetchDriverBookingPerformance(params),
    staleTime: 1 * 60 * 1000,
  })
}

export const useVehicleBookingCounts = (params) => {
  return useQuery({
    queryKey: ["vehicleBookingCounts", params],
    queryFn: () => fetchVehicleBookingCounts(params),
    staleTime: 1 * 60 * 1000,
  })
}

export const useVehicleCategoryDistribution = (params) => {
  return useQuery({
    queryKey: ["vehicleCategoryDistribution", params],
    queryFn: () => fetchVehicleCategoryDistribution(params),
    staleTime: 1 * 60 * 1000,
  })
}

export const useTodayRevenueExpense = () => {
  return useQuery({
    queryKey: ["todayRevenueExpense"],
    queryFn: fetchTodayRevenueExpense,
    staleTime: 1 * 60 * 1000,
  })
}

export const useVehicleAvailabilityCalendar = (params) => {
  return useQuery({
    queryKey: ["vehicleAvailabilityCalendar", params],
    queryFn: () => fetchVehicleAvailabilityCalendar(params)
  })
}